export { Link, type LinkProps } from './styled/link';
